export default __webpack_public_path__ + "static/airbnb-tablet-1486d8866a0eb74da84a10bfe43e8a4f.jpg";